'use client'

import { sessionStorageKey } from '@/constants/sessionstorage-key'
import { ArtistType } from '@/types/artist.type'
import { useRouter } from 'next/navigation'

export const useArtistRouter = () => {
  const router = useRouter()

  const getDivideArtistFirstPathname = () => {
    const firstPathname = location.pathname.split('/')[1]

    switch (firstPathname) {
      case 'hosoo':
        return 'hosoo'
      case 'loopy':
        return 'loopy'
      case 'saryeonghwa':
        return 'saryeonghwa'
      default:
        return ''
    }
  }

  const saveLastPageArtistFirstPathname = () => {
    const artistFirstPathname = getDivideArtistFirstPathname()

    if (artistFirstPathname !== '') {
      sessionStorage.setItem(sessionStorageKey.lastPageArtistFristPathname, artistFirstPathname)
    }
  }

  const getLastPageArtistFirstPathname = () => {
    return sessionStorage.getItem(sessionStorageKey.lastPageArtistFristPathname) as ArtistType
  }

  const goArtistLastMainPage = () => {
    const artistFirstPathname = getLastPageArtistFirstPathname()

    router.push(`/${artistFirstPathname}`)
  }

  const goArtistMainPage = () => {
    const artistFirstPathname = getDivideArtistFirstPathname()

    if (artistFirstPathname === '') {
      router.push('/')
      return
    }

    router.push(`/${artistFirstPathname}`)
  }

  const goArtistStockStoryPage = () => {
    const artistFirstPathname = getDivideArtistFirstPathname()

    if (artistFirstPathname === '') {
      router.push('/')
      return
    }

    router.push(`/${artistFirstPathname}/my/stock/story`)
  }

  return {
    getDivideArtistFirstPathname,
    goArtistMainPage,
    goArtistStockStoryPage,
    saveLastPageArtistFirstPathname,
    getLastPageArtistFirstPathname,
    goArtistLastMainPage,
  }
}
